"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var headlessFinanceSectionStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        financeWrapper: (_b = {
                display: 'block',
                marginBottom: '40px',
                padding: '0 30px'
            },
            _b[breakpoints.down('sm')] = {
                padding: '0 15px',
            },
            _b),
        title: {
            fontSize: typography.fontXL,
            fontWeight: 700,
            marginBottom: '10px',
            textTransform: 'uppercase',
        },
        description: {
            fontSize: typography.fontSM,
            marginBottom: '10px',
        },
        buttonContainer: {
            height: '40px',
            borderRadius: 'unset',
            maxWidth: 'fit-content',
            marginLeft: '10px',
        },
    });
}, { name: 'Checkout4_HeadlessFinanceSection' });
exports.default = headlessFinanceSectionStyles;
